import { useConfig } from "@/context/use-context";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import API from "./api";

interface AlertResponse {
	status: "success" | "error";
	alert_id: string;
}

interface CreateAlertParams {
	energy: "ELEC" | "GAS";
	alert_type: string;
	value?: number;
	unit?: string;
}

export const createAlert = async ({
	energy,
	alert_type,
	value,
	unit,
	BEARER_TOKEN,
	POD,
}: CreateAlertParams & {
	BEARER_TOKEN: string;
	POD: string;
}): Promise<AlertResponse> => {
	try {
		const response = await API.post<AlertResponse>(
			`/pods/${POD}/alerts`,
			{
				energy,
				alert_type,
				value,
				unit,
			},
			{
				headers: {
					Authorization: `Bearer ${BEARER_TOKEN}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		console.log("error", error);
		throw new Error(
			`Failed to create alert: ${error instanceof Error ? error.message : "Unknown error"}`,
		);
	}
};

// React Query Hook
export const useCreateAlert = () => {
	const config = useConfig();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (params: CreateAlertParams) =>
			createAlert({
				...params,
				BEARER_TOKEN: config.bearerToken,
				POD: config.pod?.pod_id ?? "",
			}),
		onSuccess: () => {
			// Invalidate and refetch alerts data
			queryClient.invalidateQueries({ queryKey: ["alertData"] });
		},
		onError: (error) => {
			console.error("Error creating alert:", error);
		},
	});
};
